import {AbstractView} from "../../../views/AbstractView";
import {
  IAlertInstanceController,
  IT_ALERT_INSTANCE_CONTROLLER,
  MK_ALERT_INSTANCE
} from "../_controllers/IAlertInstanceController";
import {Component, input, OnInit, output} from "@angular/core";
import {AlertInstanceModel} from "../_models/AlertInstanceModel";
import {AlertInstance} from "../../../interfaces/domain/alert/AlertInstance";
import {StandardAlertInstanceController} from "../_controllers/standard-alert-instance.controller";
import {CustomDatesService} from "../../../services/custom-dates.service";
import {DialogService} from "primeng/dynamicdialog";
import {IT_ALERT_VIEW_MODAL_CONTROLLER} from "../../alert-view-modal/_controllers/IAlertViewModalController";
import {AlertViewModalController} from "../../alert-view-modal/_controllers/alert-view-modal.controller";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {AlertCommentRepository} from "../../../repositories/alert-comment.repository";
import {AlertFeedbackRepository} from "../../../repositories/alert-feedback.repository";
import {AlertRuleHistoryRepository} from "../../../repositories/alert-rule-history.repository";
import {AlertService} from "../../../services/alert-service";
import {RemedyRepository} from "../../../repositories/remedy.repository";
import {AssetRepository} from "../../../repositories/asset.repository";
import {LineRepository} from "../../../repositories/line.repository";
import {UserRepository} from "../../../repositories/user.repository";

@Component({
  selector: 'link-alert-instance',
  templateUrl: './alert-instance.view.html',
  styleUrls: ['./alert-instance.view.scss'],
  providers: [
    CustomDatesService,
    DialogService,
    ControllerEventBus,
    AlertCommentRepository,
    AlertFeedbackRepository,
    AlertCommentRepository,
    AlertRuleHistoryRepository,
    RemedyRepository,
    AssetRepository,
    LineRepository,
    UserRepository,
    AlertService,
    { provide: IT_ALERT_INSTANCE_CONTROLLER, useClass: StandardAlertInstanceController },
    { provide: IT_ALERT_VIEW_MODAL_CONTROLLER, useClass: AlertViewModalController },
  ]
})
export class AlertInstanceView extends AbstractView<IAlertInstanceController> implements OnInit {

  mode = input.required<'toast'|'list'>();

  alertInstance = input.required<AlertInstance>();

  onClose = output<any>();
  onSelect = output<any>();

  protected readonly model: AlertInstanceModel;

  constructor() {
    super(IT_ALERT_INSTANCE_CONTROLLER);

    this.model = this.getModel(MK_ALERT_INSTANCE);
  }

  ngOnInit() {
    this.handle('Init', {
      alertInstance: this.alertInstance(),
      mode: this.mode(),
    });
  }

  protected closeClicked(event: any): void {
    this.onClose.emit(event);
  }

  protected selected(event: any): void {
    this.onSelect.emit(event);
  }
}
